export const overlayToken = {
  overlayOpacity: 0.4,
  overlayRootScale: 0.93,
};
